/** @jsx jsx */
import { jsx } from '@emotion/core'
import { TableCell, TableRow, Tooltip, useTheme } from 'bold-ui'
import { ParteBucalEnum } from 'graphql/types.generated'
import { useMemo } from 'react'

import {
  getPeriogramaCompletoCondicao,
  PeriogramaCompletoCondicao,
  PeriogramaCompletoFace,
  PeriogramaCompletoQuadrante,
} from './model'
import { periogramaCompletoTableStyles } from './PeriogramaCompletoTable'

export interface PeriogramaCompletoTableRowProps {
  quadrante: PeriogramaCompletoQuadrante
  face: PeriogramaCompletoFace
  dentes: ParteBucalEnum[]
  condicao: PeriogramaCompletoCondicao
  renderCell(
    key: string | number,
    quadrante: PeriogramaCompletoQuadrante,
    dente: ParteBucalEnum,
    face: PeriogramaCompletoFace,
    condicao: PeriogramaCompletoCondicao
  ): React.ReactNode
}

export default function PeriogramaCompletoTableRow(props: PeriogramaCompletoTableRowProps) {
  const { face, quadrante, dentes, condicao: condicaoEnum, renderCell } = props

  const theme = useTheme()
  const classes = useMemo(() => periogramaCompletoTableStyles(theme), [theme])

  const condicao = useMemo(() => getPeriogramaCompletoCondicao(condicaoEnum), [condicaoEnum])

  return (
    <TableRow>
      <Tooltip text={condicao.longTitle}>
        <TableCell style={classes.firstColumn}>{condicao.title}</TableCell>
      </Tooltip>

      {dentes.map((dente, index) => renderCell(index, quadrante, dente, face, condicaoEnum))}
    </TableRow>
  )
}
